import React, { useEffect, useState } from "react";
import { Collapse, makeStyles } from "@material-ui/core";
import SEO from "../../components/SEO";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import clsx from "clsx";

import "swiper/css";
import "swiper/css/autoplay";

import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import Link from "../../components/v2/Link";
import ClientScroll from "../../components/v4/clientScroll/ClientScroll";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import FaqSection from "../../components/v4/FaqSection/FaqSection";

import broadcastImg1 from "../../images/v4/user-based-tools/teamCollaboration/images/broadcastImg1.webp";
import broadcastImg2 from "../../images/v4/user-based-tools/teamCollaboration/images/broadcastImg2.webp";

import clientLogo1 from "../../images/v4/salesReps/clientLogo/client1.png";
import clientLogo2 from "../../images/v4/salesReps/clientLogo/client2.png";
import clientLogo3 from "../../images/v4/salesReps/clientLogo/client3.png";
import clientLogo4 from "../../images/v4/salesReps/clientLogo/client4.png";
import clientLogo5 from "../../images/v4/salesReps/clientLogo/client5.png";
import clientLogo6 from "../../images/v4/salesReps/clientLogo/client6.png";
import clientLogo7 from "../../images/v4/salesReps/clientLogo/client7.png";

import benefitIcon1 from "../../images/v4/user-based-tools/teamCollaboration/icons/benefitIcon1.svg";
import benefitIcon2 from "../../images/v4/user-based-tools/teamCollaboration/icons/benefitIcon2.svg";
import benefitIcon3 from "../../images/v4/user-based-tools/teamCollaboration/icons/benefitIcon3.svg";
import benefitIcon4 from "../../images/v4/user-based-tools/teamCollaboration/icons/benefitIcon4.svg";
import benefitIcon5 from "../../images/v4/user-based-tools/teamCollaboration/icons/benefitIcon5.svg";
import benefitIcon6 from "../../images/v4/user-based-tools/teamCollaboration/icons/benefitIcon6.svg";

import growingIcon1 from "../../images/v4/user-based-tools/teamCollaboration/icons/growingIcon1.svg";
import growingIcon2 from "../../images/v4/user-based-tools/teamCollaboration/icons/growingIcon2.svg";
import growingIcon3 from "../../images/v4/user-based-tools/teamCollaboration/icons/growingIcon3.svg";
import growingIcon4 from "../../images/v4/user-based-tools/teamCollaboration/icons/growingIcon4.svg";
import growingIcon5 from "../../images/v4/user-based-tools/teamCollaboration/icons/growingIcon5.svg";
import growingIcon6 from "../../images/v4/user-based-tools/teamCollaboration/icons/growingIcon6.svg";

import leadCaptureIcon from "../../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../../images/v4/industryPage/videoConference.png";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";

import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import heroSectionImg from "../../images/v4/user-based-tools/teamCollaboration/images/heroSectionImg.webp";
import heroSectionBg from "../../images/v4/user-based-tools/teamCollaboration/images/heroSectionBg.png";
import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import benefitSectionBg from "../../images/v4/user-based-tools/teamCollaboration/images/benefitSectionBg.png";
import growingBussinessBg from "../../images/v4/user-based-tools/teamCollaboration/images/growingBussinessBg.png";
import combineSectionBg from "../../images/v4/user-based-tools/teamCollaboration/images/combineSectionBg.png";
import compareBg from "../../images/v4/user-based-tools/messagingCommunication/images/compareBg.png";

import compareItemImg1 from "../../images/v4/user-based-tools/teamCollaboration/images/compareItemImg1.webp";
import compareItemImg2 from "../../images/v4/user-based-tools/teamCollaboration/images/compareItemImg2.webp";
import compareItemImg3 from "../../images/v4/user-based-tools/teamCollaboration/images/compareItemImg3.webp";
import compareItemImg4 from "../../images/v4/user-based-tools/teamCollaboration/images/compareItemImg4.webp";
import compareItemImg5 from "../../images/v4/user-based-tools/teamCollaboration/images/compareItemImg5.webp";

const useStyles = makeStyles((theme) => ({
  whatsappSection: {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    padding: "60px 0",
    backgroundImage: `url(${heroSectionBg})`,
    "& $aiSectionLeft": {
      width: "53%",
      gap: "25px",
    },
    "& .countryHighlight": {
      background: "linear-gradient(90deg, #25D366 0%, #0D4D85 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& .buttonContaienr": {
      marginTop: "20px",
    },
    "& .container": {
      paddingBottom: "40px",
    },

    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      marginTop: "70px",
    },
    "@media only screen and (max-width: 600px)": {
      backgroundPosition: "bottom",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      "& $aiSectionLeft": {
        width: "100%",
        gap: "16px",
        "&  .wpLogo": {
          width: "40px",
          height: "40px",
          position: "relative",
          top: "10px",
        },
      },
      paddingTop: "0px",
      "& .centerContainer": {
        width: "100%",
        marginTop: "30px",
      },
      "& .container": {
        paddingBottom: "20px",
      },
      "& .buttonContaienr": {
        marginTop: "10px",
      },
    },
  },
  aiSectionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  aiSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "40%",
    gap: "20px",
    "& .highlighterText": {
      background: "linear-gradient(90deg, #7AFFAB 0%, #80C8FF 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    // "&  .wpLogo": {
    //   width: "40px",
    //   height: "40px",
    //   position: "relative",
    //   top: "10px",
    // },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  aiSectionRight: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },

  listContainer: {
    display: "flex",
    marginTop: "16px",
    width: "100%",
    flexWrap: "wrap",
    // flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      minWidth: "100%",
      gap: "8px",
      marginTop: "0",
    },
  },
  listItem: {
    background: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid rgba(241, 223, 255, 0.40)",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {},
    // color: "#A2BED3",
  },

  broadcastContainer: {
    // backgroundImage: `url(${broadcastBg})`,
    // backgroundPosition: "top",
    // backgroundSize: "cover",
    // backgroundRepeat: "no-repeat",
    background: "#F0FCFF",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
    },
    "& $broadcastRightContainer": {
      width: "50%",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
      "& $broadcastRightContainer": {
        width: "100%",
      },
    },
  },

  workflowBroadcastContainerInner: {
    width: "100%",
    display: "flex",
    position: "relative",
    alignItems: "stretch",
    gap: "30px",
    padding: "0 4rem 4rem !important",
    overflow: "auto",
    justifyContent: "flex-start",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0 15px 40px !important",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "0 19rem 6rem !important",
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
    },
  },
  broadcastBox: {
    display: "flex !important",
    padding: "40px",
    background: "#009249",
    alignItems: "center",
    borderRadius: "20px",
    justifyContent: "space-between",
    minWidth: "70%",
    maxWidth: "70%",
    minHeight: "450px",
    maxHeight: "450px",
    // minHeight: "415px",
    // maxHeight: "415px",
    transition: "0.3s ease",
    overflow: "hidden",
    "&.active": {
      transform: "scale(1) !important",
    },
    "&.inActive": {
      transform: "scale(0.8) !important",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "20px",
      gap: "15px",
      flexDirection: "column-reverse",
      minHeight: "760px",
      justifyContent: "flex-end",
      minWidth: "90%",
      maxWidth: "90%",
    },
    "@media only screen and (min-width: 1800px)": {
      minWidth: "80%",
      maxWidth: "80%",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "60%",
    gap: "10px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "10px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "flex-start",
    },
  },

  benefitSection2: {
    backgroundImage: `url(${benefitSectionBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      display: "flex",
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      "& h2": {
        width: "100%",
      },
      "& p": {
        textAlign: "left",
        width: "40%",
      },
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
        gap: "16px",
        "& h2": {
          width: "100%",
          textAlign: "left",
        },
        "& p": {
          textAlign: "left",
          width: "100%",
        },
      },
    },
  },
  benefitContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "stretch",
    gap: "24px",
    rowGap: "24px",
    margin: "60px 0 0",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  benefitBox: {
    display: "flex",
    border: "1px solid rgba(255, 255, 255, 0.10)",
    background: "rgba(255, 255, 255, 0.10)",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
    width: "32%",
    padding: "24px",
    borderRadius: "16px",
    transition: "0.3s ease",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "12px",
      padding: "16px",
    },
    // "&:hover": {
    //   transition: "0.3s ease",
    //   background: "linear-gradient(117deg, #F2E1FF 0.97%, #E9FFFF 100%)",
    //   "@media only screen and (max-width: 600px)": {
    //     "&:hover": {
    //       background: "transparent",
    //     },
    //   },
    // },
  },

  growingBusiness: {
    backgroundImage: `url(${growingBussinessBg})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingBottom: "80px",
    position: "relative",
    "& .header": {
      width: "80%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      gap: "32px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "50px",
      "& .header": {
        width: "100%",
      },
    },
  },
  broadcastContainerInner: {
    gap: "30px",
    width: "100%",
    display: "flex",
    padding: "1rem 16rem 0 16rem",
    paddingBottom: "16px !important",
    alignItems: "stretch",
    justifyContent: "flex-start",
    "& swiper-wrapper": {
      alignItems: "stretch !important",
    },

    "& $featureContainer": {
      width: "31%",
      height: "auto  !important",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "16px 15px !important",
    },
    // "@media only screen and (min-width: 1900px)": {
    //   paddingLeft: "40rem !important",
    //   paddingRight: "40rem !important",
    // },
  },
  featureContainer: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "32%",
    gap: "22px",
    boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.15)",
    borderRadius: "16px",
    background: "#fff",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    textAlign: "left",
    "& p": {
      // color: $black2,
      width: "90%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& p": {
        width: "100%",
      },
    },
  },

  combineSection: {
    position: "relative",
    paddingTop: "64px",
    backgroundImage: `url(${combineSectionBg})`,
    backgroundSize: "cover",
    paddingBottom: "220px",
    "@media(max-width:600px)": {
      paddingBottom: "90px",
    },
  },
  bussinessSuccesSection: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    // backgroundImage: `url(${bussinessSuccessbg})`,
    paddingTop: "40px",
    "& .logos-container": {
      background: "transparent",
      "&::before,&::after": {
        display: "none",
      },
      "& .logo": {
        backgroundColor: "#208EEC26",
        color: "#B6DDFF",
        "& img": {
          width: "48px",
          height: "48px",
        },
      },
      "@media only screen and (max-width: 768px)": {
        paddingBottom: "0px!important",
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "100px 0",
      paddingTop:'0'
    },
  },
  bussinessSuccessContainer: {
    display: "flex",
    alignItems: "center",
    maxWidth: "1200px",
    margin: "0 auto",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  integrationHeaderItem: {
    width: "100%",
    marginBottom: "90px",
    color: "#fff",
    "& h2": {
      margin: "16px 0 32px",
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& h2": {
        paddingRight: "40px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
      padding: "0 15px",
      "& p": {
        textAlign: "center",
      },
      "& h2": {
        textAlign: "center",
        paddingRight: "0",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& h2": {
        textAlign: "center",
      },
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
  },

  compareSection: {
    backgroundImage: `url(${compareBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "top",
    paddingTop: "280px",
    "@media only screen and (max-width: 600px)": {
      paddingTop: "160px",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "15px",
    },
  },

  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "12px",
    },
  },

  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },

  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },

  body: {
    textAlign: "left",
    margin: "10px 0  ",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },
  wpFaq: {
    // paddingTop: "120px",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },

  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
}));

const TeamCollaboration = () => {
  const classes = useStyles();
  const [activeCompare, setActiveCompare] = useState("#section0");
  const [activeAccordian, setActiveAccordian] = useState(0);

  const allIcons = [
    {
      img: leadCaptureIcon,
      title: "Auto lead capture",
    },
    {
      img: contactManagemntIcon,
      title: "Contact management",
    },
    {
      img: pipelineIcon,
      title: "Pipeline management",
    },
    {
      img: omniChannelIcon,
      title: "Omnichannel CRM",
    },
    {
      img: emailMarketingIcon,
      title: "Email marketing",
    },
    {
      img: quatationIcon,
      title: "Quotation generation",
    },
    {
      img: salesForecastIcon,
      title: "Sales forecasting",
    },
    {
      img: opportunityMangeIcon,
      title: "Opportunity management",
    },
    {
      img: aiChatbotIcon,
      title: "AI chatbot",
    },
    {
      img: whatsappCrmIcon,
      title: "WhatsApp CRM",
    },
    {
      img: mobileCrmIcon,
      title: "Mobile CRM",
    },
    {
      img: utmTrackingIcon,
      title: "UTM tracking",
    },
    {
      img: realTimeDashboardIcon,
      title: "Real-time dashboard",
    },
    {
      img: voipToolIcon,
      title: "VOIP tool integration",
    },
    {
      img: videoConferencingIcon,
      title: "Video conferencing",
    },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title)
    );

    const logotrack1 = [];
    const logotrack2 = [];
    const logotrack3 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 3) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
        case 2:
          logotrack3.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
      logotrack3,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2, logotrack3 } = distributeIcons(allIcons);

  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo-2");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 25 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row-2").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const clientScrollData = {
    title: "Trusted by top brands across industries",
    backgroundImage: "",
    logos: [
      {
        img: clientLogo1,
      },
      {
        img: clientLogo2,
      },
      {
        img: clientLogo3,
      },
      {
        img: clientLogo4,
      },
      {
        img: clientLogo5,
      },
      {
        img: clientLogo6,
      },
      {
        img: clientLogo7,
      },
    ],
    directions: ["left", "right", "left"],
    speeds: [0.8, 0.4, 0.8],
  };

  const broadcastList = [
    {
      heading: "Jira integration with CRM",
      content:
        "Pepper Cloud’s Jira integration turns your CRM into one of the best workflow management tools, ideal for seamless project tracking and collaboration.",
      img: broadcastImg1,
      alt: "Mailchimp CRM system integration",
      link: "https://peppercloud.com/crm-integrations/project-management-jira-integration/",
      background: "linear-gradient(180deg, #0A2F4F 0%, #2576BB 100%)",
      points: [
        "Receive real-time Jira updates directly within Pepper Cloud CRM.",
        "Resolve issues and manage tasks without switching platforms.",
        "Monitor project health, deadlines, and deliverables in one place.",
      ],
    },
    {
      heading: "Confluence integration with CRM ",
      content:
        "The Confluence integration with CRM allows teams to collaborate better by embedding knowledge sharing within the CRM.",
      img: broadcastImg2,
      alt: "MailerLite with Pepper Cloud CRM integration",
      link: "https://peppercloud.com/crm-integrations/confluence-knowledge-base-software/",
      background: "linear-gradient(180deg, #31114B 0%, #783CA8 100%)",
      points: [
        "View and edit Confluence pages from the CRM interface.",
        "Centralise project notes, documentation, and updates.",
        "Instantly share strategies and information across your team.",
      ],
    },
  ];

  const benefits = [
    {
      title: "Centralised project tracking",
      desc: "The best workflow management tools like Pepper Cloud CRM offer centralised  visibility into deadlines and tasks.",
      icon: benefitIcon1,
    },
    {
      title: "Enhanced communication",
      desc: "Pepper Cloud offers top collaboration tools, with easy access to Confluence updates right from your CRM.",
      icon: benefitIcon2,
    },
    {
      title: "Task management and issue resolution",
      desc: "Jira CRM integration boosts workflows with faster issue resolution and task prioritisation.",
      icon: benefitIcon3,
    },
    {
      title: "Real-time updates",
      desc: "Sync updates across Pepper Cloud CRM, Jira, and Confluence instantly, keeping teams aligned and informed.",
      icon: benefitIcon4,
    },
    {
      title: "Improved team productivity",
      desc: "The best collaboration software integrates project tools into one interface, eliminating the need to switch apps constantly.",
      icon: benefitIcon5,
    },
    {
      title: "Smarter decisions with AI insights",
      desc: "Get AI-powered recommendations and summaries from Confluence, helping teams make informed decisions faster.",
      icon: benefitIcon6,
    },
  ];

  const growingList = [
    {
      icon: growingIcon1,
      heading: "Seamless Jira integration",
      text: "Track tasks, bugs, and project milestones directly within the CRM.",
    },
    {
      icon: growingIcon2,
      heading: "Seamless Confluence integration",
      text: "Use Pepper Cloud’s Confluence integration for quick access to docs, team knowledge, and strategies.",
    },
    {
      icon: growingIcon3,
      heading: "Real-time data synchronisation",
      text: "Keep workflows fluid with up-to-the-second syncing across tools.",
    },
    {
      icon: growingIcon4,
      heading: "Intuitive user interface",
      text: "Designed for ease, the CRM is accessible even to non-technical users.",
    },
    {
      icon: growingIcon5,
      heading: "Advanced project tracking",
      text: "Optimise performance with integrated CRM for project tracking.",
    },
    {
      icon: growingIcon6,
      heading: "Enhanced team productivity tools",
      text: "From docs to tasks, Pepper Cloud ensures smooth project execution with top workflow tools.",
    },
  ];

  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot CRM",
    "Zoho CRM",
    "Salesforce CRM",
    "Pipedrive CRM",
  ];

  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM is one of the top choices for team collaboration with CRM, featuring seamless Jira integration with CRM and Confluence integration with CRM. It centralises project tracking, documentation, and task management with real-time synchronisation, ensuring smooth team collaboration and productivity.",
      img: compareItemImg1,
      alt: "Pepper Cloud CRM",
      features: [
        {
          title: "Real-time data sync",
          desc: "Instantly synchronise tasks, project updates, and documentation between Pepper Cloud CRM, Jira, and Confluence, ensuring real-time accuracy and seamless operations.",
        },
        {
          title: "Advanced project tracking",
          desc: "Manage milestones, deadlines, and task assignments directly from your CRM dashboard.",
        },
        {
          title: "Centralised knowledge base",
          desc: "Access Confluence documents and project notes without leaving the CRM interface.",
        },
        {
          title: "Enhanced team productivity",
          desc: "Boost efficiency with smart automation and intuitive navigation.",
        },
      ],
    },
    {
      title: "HubSpot CRM",
      desc: "A good choice for its robust marketing and sales features. Ideal for businesses looking for a well-rounded CRM solution with smooth project tracking. While it offers basic team collaboration with CRM, its integration with Jira and Confluence is limited.",
      img: compareItemImg2,
      alt: "HubSpot CRM",
      features: [
        {
          title: "Lead nurturing",
          desc: "Automate follow-ups and client interactions.",
        },
        {
          title: "Pipeline management",
          desc: "Visualise sales pipelines for better opportunity tracking.",
        },
        {
          title: "Limited Jira & Confluence support",
          desc: "Basic project visibility, lacking deep integration.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "A practical choice for small to medium businesses seeking affordable team collaboration with CRM features. While it provides basic Jira integration with CRM and Confluence integration with CRM, it falls short compared to Pepper Cloud CRM's seamless synchronisation and project tracking capabilities.",
      img: compareItemImg3,
      alt: "Zoho CRM",
      features: [
        {
          title: "Customisable workflows",
          desc: "Personalise business processes to match your project needs.",
        },
        {
          title: "Basic project sync",
          desc: "Integrates with Jira, but lacks full synchronisation.",
        },
        {
          title: "Minimal Confluence integration",
          desc: "Limited access to collaborative documents.",
        },
      ],
    },
    {
      title: "Salesforce CRM",
      desc: "A robust choice for large enterprises needing custom project management solutions. It offers Jira integration with CRM through third-party apps but has limited support for Confluence integration with CRM.",
      img: compareItemImg4,
      alt: "Salesforce CRM",
      features: [
        {
          title: "Custom app development",
          desc: "Tailor solutions to specific project needs.",
        },
        {
          title: "Advanced analytics",
          desc: "Deep insights into project metrics.",
        },
        {
          title: "Minimal Confluence support",
          desc: "Requires third-party plugins for integration.",
        },
      ],
    },
    {
      title: "Pipedrive CRM",
      desc: "Great for deal tracking and sales management, but falls short in team collaboration with CRM features. Its support for Jira and Confluence is minimal compared to Pepper Cloud CRM.",
      img: compareItemImg5,
      alt: "Pipedrive CRM",

      features: [
        {
          title: "Deal management",
          desc: "Track sales opportunities efficiently.",
        },
        {
          title: "Basic task management",
          desc: "Good for small teams but lacks full Jira and Confluence integration.",
        },
        {
          title: "Not ideal for project tracking",
          desc: "Limited visibility for complex projects.",
        },
      ],
    },
  ];

  const faqs = [
    {
      question: "Why is team collaboration with CRM important?",
      answer: (
        <>
          Integrating the best collaboration software with CRM ensures
          communication, project tracking, and knowledge sharing happen in one
          place.
        </>
      ),
    },
    {
      question: "What is a workflow management tool?",
      answer: (
        <>
          A workflow management tool is software that helps teams automate,
          track, and optimise tasks and processes, improving efficiency and
          collaboration across projects.
        </>
      ),
    },
    {
      question: "How does Jira integration with CRM help in project tracking?",
      answer: (
        <>
          It connects CRM to project workflows, enabling real-time updates and
          task management from a single dashboard.
        </>
      ),
    },
    {
      question: "What are the benefits of Confluence integration with CRM?",
      answer: (
        <>
          It embeds documentation and team notes within the CRM, boosting
          collaboration and informed decision-making.
        </>
      ),
    },
    {
      question:
        "Why is Pepper Cloud CRM the best choice for team collaboration with CRM?",
      answer: (
        <>
          It offers deep Jira and Confluence teams integration, smart
          automation, and an intuitive interface.
        </>
      ),
    },
    {
      question: "Can Pepper Cloud CRM be used for project tracking?",
      answer: (
        <>
          Yes, Pepper Cloud CRM is purpose-built as one of the best workflow
          management tools for project tracking and team efficiency.
        </>
      ),
    },
    {
      question: "Is Pepper Cloud CRM suitable for small and medium businesses?",
      answer: (
        <>
          Absolutely. It's scalable and easy to use, making it ideal for SMEs.
        </>
      ),
    },
    {
      question: "How secure is data within Pepper Cloud CRM?",
      answer: (
        <>
          Enterprise-grade encryption, access controls, and regular backups
          ensure top-notch data protection.
        </>
      ),
    },
    {
      question:
        "Does Pepper Cloud CRM require technical expertise to integrate with Jira and Confluence?",
      answer: (
        <>
          No. It features a user-friendly setup for Jira and Confluence teams
          integration, requiring minimal technical know-how.
        </>
      ),
    },
  ];

  return (
    <main>
      <SEO
        title={
          "Top Workflow Management Tool with Confluence & Jira Integration"
        }
        pathname={
          "https://peppercloud.com/user-based-tools/best-workflow-management-tools/"
        }
        keywords="Best workflow management tools- 20, Best collaboration software- 70, confluence teams integration-30, What is a workflow management tool-20"
        description={
          "Boost team productivity with the best workflow management tools. Integrate Jira & Confluence for real-time updates, seamless collaboration, and centralised project tracking inside Pepper Cloud CRM."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        scripts={[`gtag('event', 'whatsapp_support_crm_generate_lead', {});`]}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What are the benefits of WhatsApp CRM for customer service?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "WhatsApp CRM improves response speed, ensures no query goes unanswered, enables team collaboration, and provides complete visibility into customer interactions. It also helps SMEs scale customer service without increasing staff costs.",
                },
              },
              {
                "@type": "Question",
                name: "What are the top 3 features which make our CRM ideal for customer support on WhatsApp?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Our CRM offers a smart ticketing system with automation rules, a multi-channel inbox with complete customer history, and real-time agent availability and assignment, making it ideal for customer support on WhatsApp.",
                },
              },
              {
                "@type": "Question",
                name: "How to choose the best WhatsApp CRM for customer support?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "The best WhatsApp CRM should integrate seamlessly with your existing systems, offer automation to handle large volumes, provide detailed analytics, and be easy to use for your support team. For SMEs, it should also be scalable and cost-effective.",
                },
              },
              {
                "@type": "Question",
                name: "Can WhatsApp CRM work for small and medium businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. WhatsApp CRM is designed to scale with your business. SMEs benefit from automation, ticket management, and customer history features without needing large support teams.",
                },
              },
              {
                "@type": "Question",
                name: "How secure is customer data in a WhatsApp CRM system?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Most WhatsApp CRM systems follow strict compliance with WhatsApp Business API policies and data protection standards. This ensures conversations and customer data remain secure and private.",
                },
              },
              {
                "@type": "Question",
                name: "Does WhatsApp CRM integrate with other business tools?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. A good WhatsApp CRM integrates with sales CRM, payment gateways, project management tools, and marketing platforms, helping you unify operations across teams.",
                },
              },
              {
                "@type": "Question",
                name: "How does WhatsApp CRM improve customer retention?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "By responding faster, personalising interactions, and keeping track of every customer’s history, WhatsApp CRM helps businesses build stronger relationships, increasing loyalty and repeat business.",
                },
              },
              {
                "@type": "Question",
                name: "What role does AI play in WhatsApp CRM for customer support?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "AI enhances support by powering chatbots, automating repetitive queries, analysing sentiment, and assisting agents with quick, accurate responses—improving both efficiency and customer experience.",
                },
              },
              {
                "@type": "Question",
                name: "Can multiple team members manage the same customer conversation?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. With collaboration tools inside WhatsApp CRM, multiple agents can view, comment, and resolve queries together without losing context or duplicating work.",
                },
              },
              {
                "@type": "Question",
                name: "How does WhatsApp CRM support omnichannel communication?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A WhatsApp CRM combines WhatsApp, email, and other messaging platforms into one inbox, allowing teams to respond consistently across all channels.",
                },
              },
            ],
          },
        ]}
      />

      <section className={classes.whatsappSection}>
        <div className="container">
          <div className={classes.aiSectionContainer}>
            <div className={classes.aiSectionLeft}>
              <motion.h1
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-64 font-white"
              >
                Best workflow management tools for teams
              </motion.h1>
              <motion.p
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-regular font-18 font-white"
              >
                Maximise team efficiency with one of the best workflow
                management tools. Integrate with Jira and Confluence for
                seamless project tracking and enhanced communication.
              </motion.p>
              <div className={classes.listContainer}>
                <motion.div
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className={classes.listItem}
                >
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"WhatsApp CRM for customer service"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-white  font-18">
                    Real-time synchronisation
                  </p>
                </motion.div>
                <motion.div
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className={classes.listItem}
                >
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"WhatsApp CRM for customer service"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-white font-18">
                    Smart automation
                  </p>
                </motion.div>
                <motion.div
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className={classes.listItem}
                >
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"WhatsApp CRM for customer service"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-white font-18">
                    Unified collaboration
                  </p>
                </motion.div>
              </div>
              <div className="buttonContaienr">
                <Link
                  className="primaryButton font-16 font-wix-medium font-white"
                  to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
                >
                  Book a free demo
                </Link>
              </div>
            </div>
            <div className={classes.aiSectionRight}>
              <LazyImage
                source={heroSectionImg}
                width="100%"
                alt="Best workflow management tools for teams"
              />
            </div>
          </div>
        </div>
      </section>

      <ClientScroll
        {...clientScrollData}
        // background={topIndustiesBg}
        darkLayout={false}
      />

      <section className={classes.broadcastContainer}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-black"
            >
              Boost teamwork with the best workflow management tools
            </motion.h2>
          </div>
        </div>
        <Swiper
          slidesPerView={1}
          centeredSlides={true}
          modules={[Autoplay]}
          speed={5000}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          spaceBetween={30}
          grabCursor={true}
          className={classes.workflowBroadcastContainerInner}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: "auto",
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 10,
              centeredSlides: false,
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: "auto",
              centeredSlides: true,
              spaceBetween: 30,
              grabCursor: true,
            },
          }}
        >
          {broadcastList.map((point, index) => (
            <SwiperSlide
              className={classes.broadcastBox}
              style={{ background: point.background }}
            >
              <div className={classes.broadcastLeftContainer}>
                <p className="font-40 font-wix-medium font-white">
                  {point.heading}
                </p>
                <p className="font-18 font-wix-regular font-white mt10 mb20">
                  {point.content}
                </p>
                {point.points.map((content) => (
                  <div className={classes.cardPointer}>
                    <LazyImage
                      source={whiteCheckCircle}
                      alt={"pointer"}
                      className={clsx(classes.cardPointer)}
                    />
                    <p className="font-wix-regular font-18 font-white">
                      {content}
                    </p>
                  </div>
                ))}
                <a
                  className="loginButton font-wix-medium font-16 mt20"
                  href={point.link}
                >
                  Know more
                </a>
              </div>
              <div className={classes.broadcastRightContainer}>
                <img
                  src={point.img}
                  alt={point.alt}
                  className={classes.broadcastImg}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <section className={classes.benefitSection2}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Benefits of using workflow management tools
            </motion.h2>
            {/* <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-18 font-white"
            >
              Go beyond basic tools with an intelligent CRM designed to
              accelerate online business growth and streamline e-commerce
              operations.
            </motion.p> */}
          </div>
          <div className={classes.benefitContainer}>
            {benefits.map((benefit) => (
              <div className={classes.benefitBox}>
                <img src={benefit.icon} alt={benefit.title} />
                <p className="font-wix-semibold font-24 font-white">
                  {benefit.title}
                </p>
                <p className="font-wix-regular font-18 font-white">
                  {benefit.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Why is Pepper Cloud the best  CRM email integration
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-20 color-black1"
            >
              Go beyond basic tools with an intelligent CRM designed to
              accelerate online business growth and streamline e-commerce
              operations.
            </motion.p>
          </div>
        </div>
        <Swiper
          slidesPerView={3.3}
          // centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          loop={false}
          speed={5000}
          modules={[Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          // freeMode={true}
          className={classes.broadcastContainerInner}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: 1.3,
              slidesPerGroup: 1,
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 10,
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: 3.3,
              centeredSlides: false,
              spaceBetween: 30,
              grabCursor: true,
            },
          }}
        >
          {growingList.map((feature) => (
            <SwiperSlide className={classes.featureContainer}>
              <LazyImage
                source={feature.icon}
                alt={feature.heading}
                className={classes.featureIcon}
                // alt={listItem.alt}
              />
              <p className="font-wix-semibold font-24 color-black2">
                {feature.heading}
              </p>
              <p className="font-wix-medium font-18 color-black3">
                {feature.text}
              </p>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div> */}
      </section>

      <section className={classes.combineSection}>
        <div className={classes.bussinessSuccesSection}>
          <div className={classes.bussinessSuccessContainer}>
            <div className={classes.integrationHeaderItem}>
              <div className={classes.integrationContent}>
                <motion.p
                  className="font-wix-semibold font-20 color-black7"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Features
                </motion.p>
                <motion.h2
                  className="font-wix-semibold font-56 color-black7"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Tailored for business success
                </motion.h2>
                <motion.p
                  className="font-wix-regular font-18"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  The best CRM for sales reps who want to streamline their sales
                  process, stay organised, and win more deals.
                </motion.p>
              </div>
            </div>

            <section className="sales-logo-carousel">
              <div className="logos-container">
                <div className="scroll-container">
                  <div
                    className="logos-row-2"
                    data-direction="left"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {logotrack1.map((logo) => (
                        <div
                          className="logo-2 logo font-18 font-wix-medium"
                          key={logo.title}
                        >
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className="logos-row-2"
                    data-direction="right"
                    data-speed="0.4"
                  >
                    <div className="logos-track">
                      {logotrack2.map((logo) => (
                        <div className="logo-2 logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className="logos-row-2"
                    data-direction="left"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {logotrack3.map((logo) => (
                        <div className="logo-2 logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div
                    className="logos-row-2"
                    data-direction="right"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {logotrack1.map((logo) => (
                        <div className="logo-2 logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div className={classes.absoulteCard}>
          <TruestedSection shadow background={true} />
        </div>
      </section>

      <section className={classes.compareSection}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-semibold font-56 font-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              5 Best CRM software with workflow management tool integration
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` &&
                        "font-wix-semibold"
                    )}
                    href={`#section${index}`}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    className="font-40 font-wix-semibold font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.title}
                  </h3>
                  <p
                    className="font-wix-regular font-18 font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.desc}
                  </p>
                  <img alt={data.alt} className="productImage" src={data.img} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                      >
                        <div className={classes.topFiveHeader}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                            src={downArrow}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-wix-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFF8F5"}
          faqs={faqs}
          heading={
            "Frequently asked questions for workflow management tools-FAQ"
          }
        />
      </div>

      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Empowering teams with the best workflow management tools.
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=CRM+email+integration&utm_medium=Show+me+how"
            >
              Show me how
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default TeamCollaboration;
